<script setup lang="ts">
import { AUTOPLAY_DURATIONS, AutoplayDurationType } from '@@/bits/slideshow'
import SurfaceRowDropdown from '@@/vuecomponents/SurfaceRowDropdown.vue'
import { __ } from '@@/bits/intl'
import { OzMenuRowsRow, OzMenuRowsRowStyle } from '@@/library/v4/components/OzMenuRows.vue'
import { computed } from 'vue'

const props = defineProps<{
  embedAutoplayDuration: AutoplayDurationType
  darkMode: boolean
}>()

const rows = computed(() =>
  Object.entries(AUTOPLAY_DURATIONS).map(([option, description]) => {
    return {
      htmlText: `<p class='text-body-small ${props.darkMode ? 'text-light-text-100' : 'text-dark-text-100'}'>${
        description.long
      }</p>`,
      rightIcon: option === props.embedAutoplayDuration ? 'radio_selected' : 'radio_unselected',
      rightIconSize: 24,
      rightIconHighlighted: option === props.embedAutoplayDuration,
      rowStyle: OzMenuRowsRowStyle.Secondary,
      ariaChecked: String(option === props.embedAutoplayDuration),
      eventPayload: option,
    } as OzMenuRowsRow<AutoplayDurationType>
  }),
)

const onRowSelect = (_event, payload: AutoplayDurationType) => {
  emit('select-row', payload)
}

const emit = defineEmits(['exit', 'select-row'])
</script>

<template>
  <SurfaceRowDropdown
    :field-label="__('Duration')"
    :dropdown-label="__('Slideshow embed autoplay duration dropdown')"
    :button-text="AUTOPLAY_DURATIONS[embedAutoplayDuration].long"
    :dark-mode="darkMode"
    :rows="rows"
    :dropdown-test-id="'slideshowEmbedSettingAutoplayDropdown'"
    :button-test-id="'slideshowEmbedSettingAutoplayDropdownButton'"
    @select-row="onRowSelect"
  />
</template>
